<div class="background">
  <h3 mat-dialog-title>Edit {{ data.field }} of {{ data.property }}:</h3>
  <mat-form-field class="full-width">
    <mat-label>{{ data.field }}</mat-label>
    @if (data.field == "Product Type") {
    <mat-select
      (keydown.enter)="enterEdit()"
      [formControl]="selectedProductType"
      (selectionChange)="changeProductType()"
    >
      @for (productType of (productTypes$ | async); track productType.id) {
      <mat-option id="{{ productType.id }}" [value]="productType">{{
        productType.name
      }}</mat-option>
      }
    </mat-select>
    } @if (data.field == "Version Type") {
    <mat-select
      (keydown.enter)="enterEdit()"
      [formControl]="selectedVersionType"
      (selectionChange)="changeVersionType()"
    >
      @for (versionType of (versionTypes$ | async); track versionType.id) {
      <mat-option id="{{ versionType.id }}" [value]="versionType">{{
        versionType.name
      }}</mat-option>
      }
    </mat-select>
    } @if (data.field == "Note Type") {
    <mat-select
      (keydown.enter)="enterEdit()"
      [formControl]="selectedNoteType"
      (selectionChange)="changeNoteType()"
    >
      @for (noteType of (noteTypes$ | async); track noteType.id) {
      <mat-option id="{{ noteType.id }}" [value]="noteType">{{
        noteType.name
      }}</mat-option>
      }
    </mat-select>
    } @if (data.field == "Display Note Type") {
    <mat-select
      (keydown.enter)="enterEdit()"
      [formControl]="selectedDisplayNoteType"
      (selectionChange)="changeDisplayNoteType()"
    >
      @for (displayNoteType of (noteTypes$ | async); track displayNoteType.id) {
      <mat-option id="{{ displayNoteType.id }}" [value]="displayNoteType"
        >{{ displayNoteType.name }}
      </mat-option>
      }
    </mat-select>
    } @if (data.field == "Visibility") {
    <mat-select
      [formControl]="selectedVisibility"
      (selectionChange)="changeVisibility()"
    >
      @for (visibility of (visibilities$ | async); track visibility.id) {
      <mat-option id="{{ visibility.id }}" [value]="visibility">{{
        visibility.name
      }}</mat-option>
      }
    </mat-select>
    }
  </mat-form-field>

  @if (data.field == "Version Type") {
  <mat-form-field class="full-width">
    <mat-label> Block Reason </mat-label>

    <textarea
      matInput
      rows="4"
      cols="40"
      [formControl]="blockReason"
    ></textarea>
  </mat-form-field>
  }

  <mat-card
    [ngClass]="{
      'status-edited': (editedValue$ | async) === true,
      'status-failed': (editedValue$ | async) === false,
      'status-not-edited': !editPressed
    }"
    class="edited-card"
  >
    <p *ngIf="!editPressed">Press Save to submit your change.</p>
    @if (editPressed) {
    <p *ngIf="(editedValue$ | async) === null">Editing...</p>
    <p *ngIf="(editedValue$ | async) === true">Your Change has been made.</p>
    <p *ngIf="(editedValue$ | async) === false">
      Your Change could not be made.
    </p>
    }
  </mat-card>

  <div [align]="'end'" mat-dialog-actions>
    <button [mat-dialog-close]="false" mat-raised-button>Cancel</button>
    <button
      (click)="editValue()"
      [disabled]="editDisabled || editPressed"
      color="primary"
      mat-raised-button
    >
      Save
    </button>
  </div>
</div>
